import type { SVGProps } from "react";
export interface CloudWeatherSnow01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CloudWeatherSnow01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CloudWeatherSnow01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 10a2.88 2.88 0 0 0-2.158-2.785 1.125 1.125 0 0 1-.843-1.135l.001-.08a1.875 1.875 0 0 0-3.003-1.498 1.125 1.125 0 0 1-1.538-.173 3.375 3.375 0 0 0-5.918 2.704c.084.532-.22 1.05-.727 1.234a2.377 2.377 0 0 0 .81 4.608H17l.295-.015a2.876 2.876 0 0 0 2.58-2.86m2.25 0a5.125 5.125 0 0 1-4.862 5.118l-.264.007H6.5a4.625 4.625 0 0 1-2.374-8.593V6.5a5.625 5.625 0 0 1 9.256-4.295 4.12 4.12 0 0 1 5.68 3.101A5.13 5.13 0 0 1 22.126 10Zm-4.75 11.75a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.141A1.374 1.374 0 0 1 16 20.375l.14.008c.694.07 1.235.655 1.235 1.367m2-4a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 18 16.375l.141.007a1.376 1.376 0 0 1 1.234 1.368m-10 4a1.376 1.376 0 0 1-2.743.14l-.007-.14.007-.141A1.375 1.375 0 0 1 8 20.375l.14.008c.694.07 1.235.655 1.235 1.367m4-2.5a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.235l.14.007a1.375 1.375 0 0 1 1.233 1.368Zm-6-1.5a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 6 16.375l.141.007a1.376 1.376 0 0 1 1.234 1.368"
      />
    </svg>
  );
}
